
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import TestimonialPreview from "./TestimonialPreview";
import MixpanelService from "@/services/mixpanel";

const HeroSection: React.FC = () => {

  const handleHeroSignupButton = () => {
    MixpanelService.trackButtonClick("Hero CTA - Signup", {
      section: "hero",
      action: "signup"
    });

    const ctaSection = document.querySelector('#cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleHowItWorksClick = () => {
    MixpanelService.trackButtonClick("Hero CTA - See How It Works", {
      section: "hero",
      action: "see_how_it_works"
    });

    const dashboardSection = document.querySelector('#dashboard');
    if (dashboardSection) {
      dashboardSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-28 pb-16 md:pt-36 md:pb-24 bg-gradient-to-b from-white to-neutral-50">
      <div className="container">
        <div className="grid md:grid-cols-5 gap-8 md:gap-16 lg:gap-24 items-center">
          <div className="md:col-span-2 space-y-6">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-neutral-900 leading-tight">
              Turn Real Glucose Data Into Trusted Testimonials
            </h1>
            <p className="text-lg md:text-xl text-neutral-700">
              The only platform that transforms continuous glucose monitoring into verified social proof that sells.
            </p>


            <div className="flex flex-col lg:flex-row gap-4 pt-4">
              <Button
                size="lg"
                className="bg-primary hover:bg-primary-700"
                onClick={handleHeroSignupButton}
              >
                Join The Waitlist
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-primary text-primary hover:bg-primary-50 flex items-center gap-2"
                onClick={handleHowItWorksClick}
              >
                See How It Works
                <ArrowRight size={18} className="ml-1" />
              </Button>
            </div>
          </div>

          <div className="md:col-span-3 testimony-transform-visual">
            <TestimonialPreview />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
